export const prestartList = [{
    title: 'Date',
    dataIndex: 'psDate',
    key: 'date',
    width: 45,
    render: date => {
      if (date) {
        var str = date.split("-");
        var fYear = str[0],
            fMonth = str[1],
            fDay = str[2];
  
        return fDay + "-" + fMonth + "-" + fYear;
      }
    }
  },{
    title: 'Status',
    dataIndex: 'psStatus',
    filters: [
      { text: 'Operational', value: 'Operational' },
      { text: 'Maintenance Required', value: 'Maintenance Required' },
      { text: 'Service Due', value: 'Service Due' },
    ],
    onFilter: (value, record) => record.psStatus.indexOf(value) === 0,
    width: 80,
    className: 'statusField'
  },{
    title: 'Pre-start on',
    dataIndex: 'psOn',
    key: 'prestarton',
    width: 80,
  }, {
    title: 'Comments',
    dataIndex: 'psComments',
    key: 'comments',
    width: 100,
    className: 'hideThis'

}, {
  title: 'Fix List',
  dataIndex: 'psFix',
  key: 'fixlist',
  width: 100
}, {
  title: 'From',
  dataIndex: 'psFrom',
  key: 'from',
  width: 100,
}, {
  title: 'Priority',
  dataIndex: 'psPriority',
  key: 'priority',
  width: 100,
  className: 'hideThis'
}];